<template>
    <div
        class="preferences-propver__content"
    >
        <p>
            {{ $t(`Search.propver.Preferences.${type}.1`) }}
        </p>
        <p>
            {{ $t(`Search.propver.Preferences.${type}.2`) }}
        </p>
        <template v-if="type === 'gaps'">
            <img
                width="100%"
                :src="imgSrc"
            >
            <p>
                {{ $t(`Search.propver.Preferences.${type}.3`) }}
            </p>
        </template>
    </div>
</template>

<script>
import i18n from '../../locales/i18n';

export default {
    name: 'PreferencesPropver',
    i18n,
    props: {
        type: {
            type: String,
            require: true,
            default: '',
        },
        imgSrc: {
            type: String,
            default: '',
        },
    },
};
</script>
